import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface LoginVillage { id: number; name: string; post?: string; }

@Injectable({ providedIn: "root" })
export class VillageSelectionService {
  private readonly storage = sessionStorage;
  private readonly villagesSubject = new BehaviorSubject<LoginVillage[]>(this.readVillages());
  private readonly selectedIdSubject = new BehaviorSubject<number | null>(this.readSelectedId());
  readonly villages$ = this.villagesSubject.asObservable();
  readonly selectedId$ = this.selectedIdSubject.asObservable();
  get villages(): LoginVillage[] { return this.villagesSubject.value; }
  get selectedId(): number | null { return this.selectedIdSubject.value; }
  get selectedVillage(): LoginVillage | undefined { return this.villages.find(v => v.id === this.selectedId); }

  setFromValidateMenuItem(data: any): void {
    const ids: number[] = data?.village_ids ?? [];
    const names: string[] = data?.village_names ?? [];
    const posts: string[] = data?.asha_posts ?? [];

    const villages = ids.map((id, i) => ({ id: Number(id), name: names[i] || `Village ${id}`, post: posts[i] }))
      .filter(v => Number.isFinite(v.id));
    this.storage.setItem("LoginVillages", JSON.stringify(villages));
    this.villagesSubject.next(villages);
    const saved = Number(this.storage.getItem("SelectedVillageId"));
    this.setSelectedVillage(villages.length === 1 ? villages[0].id : villages.some(v => v.id === saved) ? saved : null);
  }
  setSelectedVillage(id: number | null): void {
    if (id !== null && !this.villages.some(v => v.id === Number(id))) return;
    if (id === null) this.storage.removeItem("SelectedVillageId");
    else this.storage.setItem("SelectedVillageId", String(id));
    this.selectedIdSubject.next(id);
  }
  private readVillages(): LoginVillage[] {
    try { return JSON.parse(this.storage.getItem("LoginVillages") || "[]"); } catch { return []; }
  }
  private readSelectedId(): number | null {
    const id = Number(this.storage.getItem("SelectedVillageId"));
    return Number.isFinite(id) && id > 0 ? id : null;
  }
}
